import {createComponentToContainerMigrator} from './utils/componentMigrationHelper'
import type {PageMigrator} from '../dataMigrationRunner'

const {migratePage, version, name} = createComponentToContainerMigrator('migrateTPASectionToContainer', [
    'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    'wysiwyg.viewer.components.tpapps.TPASection'
])

export const migrateTPASectionToContainer: PageMigrator = {
    migratePage,
    name,
    version
}
